import styled, { keyframes } from 'styled-components/macro';
import { rgba } from 'polished';
import colors from 'styles/themes/colors';

const fadeIn = keyframes`
from {
  opacity: 0;
}
to {
  opacity: 1;
}
`;

export const AlertOverlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background-color: ${rgba(colors.NightBlue, 0.85)};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  animation: ${fadeIn} 0.5s 0.2s forwards;
`;

export const ConfirmAlertBody = styled('div')`
  width: 400px;
  padding: 20px 30px 10px;
  text-align: left;
  background: #fff;
  border-radius: 10px;
  /* box-shadow: 0 20px 75px rgba(0, 0, 0, 0.13); */
  color: ${colors.NightBlue};
  & > h2 {
    /* color: ${colors.NightBlue}; */
  }
`;

export const ButtonGroup = styled('div')`
  display: flex;
  justify-content: center;
  margin-top: 20px;

  & > button {
    outline: none;
    border: none;
    display: inline-block;
    cursor: pointer;

    appearance: none;
    font-size: 12px;
    padding: 9px 15px;
    margin: 0 1em;
    border: 0;
    font-weight: normal;
    color: ${colors.AccentGreen};

    &:first-of-type {
      color: ${colors.White};
      background-color: ${colors.AccentGreen};
    }
  }
`;
